import React, {Component} from 'react';
import Input from '../form/Input.jsx';
import Select from '../form/Select.jsx';
import Checkbox from '../form/Checkbox.jsx';
import {default as provinces} from '../../provinces.js';

const countries = [
    {
        name: 'United States',
        short: 'US'
    },
    {
        name: 'Canada',
        short: 'CA'
    }
];

class AddressForm extends Component {
    static defaultProps = {
        showPriceNote: true,
        showName: true,
        onAddressChange: () => {}
    }

    constructor () {
        super();
        this.createObject = this.createObject.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.focus = this.focus.bind(this);
        this.inputs = {};
        this.state = {
            address: {
                to: '',
                street: [],
                region: '',
                city: '',
                postcode: ''
            }
        };
    }

    validate (focus = false) {
        let invalid = Object.keys(this.inputs).filter((key) => {
            let input = this.inputs[key];
            return input && !input.validate();
        });

        if (invalid.length && focus) {
            let firstKey = invalid[0];
            this.inputs[firstKey].focus();
            return;
        }
        return (!invalid.length);
    }

    focus () {
        if (this.validate(true)) {
            return;
        }
        this.inputs[Object.keys(this.inputs)[0]].focus();
    }

    createObject () {
        let street = [this.inputs.street_1.getValue()];

        if (this.inputs.street_2.getValue()) {
            street.push(this.inputs.street_2.getValue());
        }

        let data = {
            street: [...street],
            city: this.inputs.city.getValue(),
            region: this.inputs.region.getValue(),
            postal_code: this.inputs.postcode.getValue(),
            country: this.inputs.region.getValue().substring(0, 2)
        };

        if (this.props.showName) {
            data.to = this.inputs.to.getValue();
        }

        if (this.props.flags) {
            data.primary_billing = this._primary_billing.isChecked();
            data.primary_shipping = this._primary_shipping.isChecked();
        }

        return data;
    }

    createString () {
        let data = this.createObject();

        return `${data.street.join(' ')} ${data.city} ${data.region} ${data.postal_code} ${data.country}`;
    }

    handleChange (e) {
        return this.props.onAddressChange(this.createObject());
    }

    render () {
        let address = this.props.address || {
            to: '',
            street: [],
            region: '',
            city: '',
            postcode: ''
        };
        return (
            <div>
                {this.props.showName && <Input ref={ref => (this.inputs.to = ref)} label="Branch or Library Name" name="to" id="to" value={address.to} required />}
                <Input ref={ref => (this.inputs.street_1 = ref)} className="spaced-half" label="Street Address" type="text" name="street[]" id="street_1" value={address.street[0]} placeholder="Street and number" required collapse />
                <Input ref={ref => (this.inputs.street_2 = ref)} label="Address 2" type="text" name="street[]" id="street_2" value={address.street[1]} placeholder="Suite, unit, building, floor, etc." hideLabel />

                <div className="row-default">
                    <div className="lg-4">
                        <Input ref={ref => (this.inputs.city = ref)} label="City" type="text" name="city" id="city" required value={address.city} />
                    </div>

                    <div className="lg-4">
                        <Select label="State/Province" ref={ref => (this.inputs.region = ref)} id="region" value={address.region} required onChange={this.handleChange}>
                            <option value="">Please select region, state or province</option>
                            {countries.map(con => {
                                return (<optgroup key={con.short} label={con.name}>
                                    {provinces.filter(prov => prov.country === con.short).map(prov => {
                                        return <option key={`${prov.country}-${prov.short}`} value={`${prov.country}-${prov.short}`}>{prov.name}</option>;
                                    })}
                                </optgroup>);
                            })}
                        </Select>
                    </div>

                    <div className="lg-4">
                        <Input label="Zip/Postal Code" ref={ref => (this.inputs.postcode = ref)} type="text" name="postcode" id="zip" required value={address.postal_code} />
                    </div>

                </div>

                {this.props.showPriceNote &&
                    <div className="alert">
                        <small>PLEASE NOTE: Pricing will reflect the standard currency for the country your organization is located in. For questions or changes please contact <a href="mailto:customerservice@findaway.com">customerservice@findaway.com</a>.</small>
                    </div>
                }

                {this.props.flags ? <div className="row-default">
                    <div className="lg-4">
                        <Checkbox ref={ref => (this._primary_billing = ref)} label="Primary Billing?" checked={address.primary_billing} id="primary_billing" />
                    </div>
                    <div className="lg-4">
                        <Checkbox ref={ref => (this._primary_shipping = ref)} label="Primary Shipping?" checked={address.primary_shipping} id="primary_shipping" />
                    </div>
                </div> : null}
            </div>
        );
    }
}

export default AddressForm;
